// eslint-disable-next-line import/prefer-default-export
export const menuItems = [
  {
    displayName: 'Unsubscribe',
    action: 'unsubscribe',
  },
];
